<template>
    <div  v-if="$page.props.auth.user.role === $GIN_ROLE">
        <h1 class="text-2xl font-bold text-blue-900 mb-3">Contacts</h1>
        <li v-for="email in emails" :key="email.id" class="relative email-wrapper col-span-1 flex border-blue-200 border rounded-md mb-4">
            <div class="flex-shrink-0 flex items-center justify-center w-16 bg-blue-50 text-blue-400 text-sm font-medium rounded-l-md py-4">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
            </div>
            <div class="flex-1 flex items-center justify-between border-t border-r border-blue-200 border bg-white rounded-r-md truncate">
                <div class="flex-1 px-4 py-2 text-sm truncate">
                    <a href="#" class="text-gray-900 font-medium hover:text-gray-600">{{ email.email }}</a>
                </div>
            </div>
        </li>
    </div>
</template>

<script>
export default {
    props: {
        emails: {
            type: Array,
        }
    },
}
</script>
